import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class WorkOrders_ds_get_work_order_details_by_workOrderIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { workOrderId: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, Description?: string, ExpectedDate?: string, LookupCode?: string, Notes?: string, ReferenceNumber?: string, Project?: { Name?: string, Owner?: { Name?: string } }, Shipment?: { LookupCode?: string }, Status?: { DisplayName?: string }, Warehouse?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.workOrderId)) {
      missingRequiredInParams.push('\'workOrderId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/WorkOrders/datasources/ds_get_work_order_details_by_workOrderId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { workOrderId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, Description?: string, ExpectedDate?: string, LookupCode?: string, Notes?: string, ReferenceNumber?: string, Project?: { Name?: string, Owner?: { Name?: string } }, Shipment?: { LookupCode?: string }, Status?: { DisplayName?: string }, Warehouse?: { Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.workOrderId)) {
      missingRequiredInParams.push('\'workOrderId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/WorkOrders/datasources/ds_get_work_order_details_by_workOrderId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { workOrderId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, Description?: string, ExpectedDate?: string, LookupCode?: string, Notes?: string, ReferenceNumber?: string, Project?: { Name?: string, Owner?: { Name?: string } }, Shipment?: { LookupCode?: string }, Status?: { DisplayName?: string }, Warehouse?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.workOrderId)) {
      missingRequiredInParams.push('\'workOrderId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/WorkOrders/datasources/ds_get_work_order_details_by_workOrderId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      workOrderId: number    }) {
        if(isNil(inParams.workOrderId)) {
          return true; 
        }
      return false;
    }
}
